import React, { useState, createContext, useContext } from 'react';
export interface Municipality {
  id: string;
  name: string;
  province: string;
  accentColor: string;
  meters: string;
}
export const municipalities: Municipality[] = [{
  id: 'ekurhuleni',
  name: 'Ekurhuleni Municipality',
  province: 'Gauteng',
  accentColor: '#0D4F5C',
  meters: '24,592'
}, {
  id: 'cape-town',
  name: 'City of Cape Town',
  province: 'Western Cape',
  accentColor: '#1E40AF',
  meters: '31,847'
}, {
  id: 'ethekwini',
  name: 'eThekwini Municipality',
  province: 'KwaZulu-Natal',
  accentColor: '#7C3AED',
  meters: '18,203'
}, {
  id: 'tshwane',
  name: 'City of Tshwane',
  province: 'Gauteng',
  accentColor: '#B45309',
  meters: '27,114'
}, {
  id: 'johannesburg',
  name: 'City of Johannesburg',
  province: 'Gauteng',
  accentColor: '#0F766E',
  meters: '42,891'
}, {
  id: 'mangaung',
  name: 'Mangaung Municipality',
  province: 'Free State',
  accentColor: '#9F1239',
  meters: '9,456'
}];
interface MunicipalityContextType {
  selected: Municipality;
  setSelected: (m: Municipality) => void;
}
const MunicipalityContext = createContext<MunicipalityContextType>({
  selected: municipalities[0],
  setSelected: () => {}
});
export function MunicipalityProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selected, setSelected] = useState<Municipality>(municipalities[0]);
  return <MunicipalityContext.Provider value={{
    selected,
    setSelected
  }} data-id="element-296">

      {children}
    </MunicipalityContext.Provider>;
}
export function useMunicipality() {
  return useContext(MunicipalityContext);
}